import { useEffect, useState } from "react";
import api from "../api";
import "bootstrap-icons/font/bootstrap-icons.css";

function formatName(c) {
  return [c?.first_name, c?.middle_name, c?.last_name].filter(Boolean).join(" ");
}

function formatAddress(c) {
  return [
    c?.address_line1,
    c?.address_line2,
    [c?.city, c?.state].filter(Boolean).join(", "),
    c?.postal_code,
  ]
    .filter(Boolean)
    .join(" ");
}

function pickPhone(c) {
  return c?.mobile_phone || c?.home_phone || "";
}

/**
 * Single-line client identity (name · phone · address) shown on the client
 * section pages, matching the line used at the top of the service modals.
 * Pass `client` if the page already has it loaded; otherwise pass `clientId`
 * and the component fetches `/clients/:id` itself.
 */
export default function ClientContactLine({ clientId, client: clientProp }) {
  const [client, setClient] = useState(clientProp || null);

  useEffect(() => {
    if (clientProp) {
      setClient(clientProp);
      return;
    }
    if (!clientId) return;
    let active = true;
    api
      .get(`/clients/${clientId}`)
      .then((res) => {
        if (active) setClient(res?.data || null);
      })
      .catch(() => {
        if (active) setClient(null);
      });
    return () => {
      active = false;
    };
  }, [clientId, clientProp]);

  const name = formatName(client);
  const phone = pickPhone(client);
  const address = formatAddress(client);

  if (!name && !phone && !address) return null;

  return (
    <div className="small text-muted d-flex flex-wrap align-items-center gap-3">
      <span className="fw-semibold text-body">{name || "—"}</span>
      {phone ? (
        <span>
          <i className="bi bi-telephone me-1" />
          {phone}
        </span>
      ) : null}
      {address ? (
        <span>
          <i className="bi bi-geo-alt me-1" />
          {address}
        </span>
      ) : null}
    </div>
  );
}
